import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, STORAGE_KEYS } from '../../constants';

// Типы для результатов поиска
export interface SearchResult {
  id: string;
  type: 'tn' | 'application' | 'route' | 'contractor' | 'driver' | 'vehicle' | 'warehouse' | 'carrier';
  title: string;
  subtitle?: string;
  description?: string;
  url: string;
  metadata?: Record<string, any>;
}

export interface SearchResponse {
  results: SearchResult[];
  total: number;
  query: string;
}

export interface SearchRequest {
  query: string;
  limit?: number;
  types?: string[];
}

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}`,
    prepareHeaders: (headers) => {
      const token =
        localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) ||
        localStorage.getItem('token') ||
        localStorage.getItem('authToken');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Search'],
  endpoints: (builder) => ({
    globalSearch: builder.query<SearchResponse, SearchRequest>({
      query: ({ query, limit = 20, types }) => ({
        url: '/search/global',
        method: 'GET',
        params: {
          q: query,
          limit,
          types: types?.join(','),
        },
      }),
      providesTags: ['Search'],
    }),
    
    searchSuggestions: builder.query<string[], string>({
      query: (query) => ({
        url: '/search/suggestions',
        method: 'GET',
        params: { q: query },
      }),
    }),
  }),
});

export const {
  useGlobalSearchQuery,
  useLazyGlobalSearchQuery,
  useSearchSuggestionsQuery,
} = searchApi;
